import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundBackground from '../pages/PagePlaygroundBackground'

type PlaygroundRunSearch = {
  runId?: string
}

export const Route = createFileRoute('/playground/background')({
  component: PagePlaygroundBackground,
  validateSearch: (search: Record<string, unknown>): PlaygroundRunSearch => ({
    runId: typeof search.runId === 'string' && search.runId.length > 0 ? search.runId : undefined
  })
})
